module.exports = __webpack_public_path__ + "static/img/active4.204eeb0d.png";